/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import { useDeleteNotificationGroupMutation } from "~/generated/graphql";
import { showError } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeleteNotificationGroup({ onSuccess }: Props) {
  const [id, setId] = useState("");
  const [deleteNotificationGroupMutation, { client, ...rest }] =
    useDeleteNotificationGroupMutation({
      onCompleted: (data) => {
        if (data.removeNotificationGroup) {
          onSuccess();
          removeFromApolloCache(
            client.cache,
            `NotificationGroup:${id}`,
            "notificationGroups"
          );
        } else {
          showError();
        }
      },
    });

  async function deleteNotificationGroup(notificationGroupId: string) {
    setId(notificationGroupId);
    await deleteNotificationGroupMutation({
      variables: {
        id: notificationGroupId,
      },
    });
  }

  return [deleteNotificationGroup, { client, ...rest }] as const;
}
